import React, { useState } from 'react';
import { useQuery } from '@common/hooks';
import { EXTENSION_OFFER_PREVIEW_QUERY } from '@working-experience/graphql';
import { ErrorHandler, Drawer } from '@common/components';
import { OfferChangeResponseDrawer } from 'works/legacy/components/offer-change-response-drawer';
import {
  ChangeRequestDialogBox,
  OfferChangeRequestActions,
  OfferInfo,
} from '@applicant-flow/components';

export function ExtensionOfferPreviewDrawer({
  open,
  onClose,
  extensionOfferId,
  offerChangeRequestId,
}: {
  open: boolean;
  onClose: () => void;
  extensionOfferId?: string;
  offerChangeRequestId?: string;
}) {
  const [showChangeResponseDrawer, setShowChangeResponseDrawer] =
    useState(false);
  const [editOffer, setEditOffer] = useState(false);

  const { data, error, loading } = useQuery(EXTENSION_OFFER_PREVIEW_QUERY, {
    variables: { id: extensionOfferId || '' },
    skip: !extensionOfferId,
  });

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="ExtensionOfferPreviewDrawer"
        messageType="contextual"
      />
    );
  }

  const extensionOffer = data?.extensionOffer;
  const application =
    extensionOffer?.staffingRequestAssignment?.staffingRequestApplication ||
    null;

  const isDataLoaded = !!(extensionOffer && application);

  const changeRequests = extensionOffer?.offerChangeRequests || [];
  const lastChangeRequest = changeRequests?.[changeRequests?.length - 1];

  return (
    <>
      <Drawer
        title="Offer Letter"
        className="show-offer-modal"
        open={open}
        onClose={onClose}
        loading={loading && !isDataLoaded}
        footer={
          isDataLoaded && (
            <OfferChangeRequestActions
              offerState={extensionOffer?.state}
              offerChangeRequests={extensionOffer?.offerChangeRequests}
              onChangeResponse={(edit) => {
                setShowChangeResponseDrawer(true);
                setEditOffer(edit);
              }}
            />
          )
        }
      >
        {isDataLoaded && (
          <OfferInfo
            application={application}
            offer={extensionOffer}
            headerSlot={
              lastChangeRequest && (
                <ChangeRequestDialogBox changeRequest={lastChangeRequest} />
              )
            }
          />
        )}
      </Drawer>

      {isDataLoaded && (
        <OfferChangeResponseDrawer
          onDrawerClose={() => setShowChangeResponseDrawer(false)}
          offerChangeRequestId={offerChangeRequestId}
          visible={showChangeResponseDrawer}
          application={application}
          offer={extensionOffer}
          edit={editOffer}
        />
      )}
    </>
  );
}
